import styled from "styled-components";

export const Directorbackground = styled.div`
  background-image: url('https://res.cloudinary.com/dvmqfke8w/image/upload/v1706687934/3_jop39w.jpg');
  height: 80vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
`;
export const Sub = styled.div`
  padding: 60px;
`;
